import * as React from 'react';
export const IcStretching = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M16 6a1.5 1.5 0 100 3 1.5 1.5 0 000-3zm1.84-4C11.26 3.11 7.06 6.54 5 20.86A1 1 0 005.86 22H6a1 1 0 001-.86A57.692 57.692 0 018.18 15l2.94 5.48a1 1 0 001.76-.94L9.38 13h.67a2.998 2.998 0 002.78-4.11l-.81-2A10 10 0 0118.16 4a1.013 1.013 0 00-.32-2zm-7 8.55a1 1 0 01-.82.44h-.54c.323-.784.704-1.543 1.14-2.27l.35.9a1.001 1.001 0 01-.1.94l-.03-.01z'
      fill='currentColor'
    />
  </svg>
);
